import React from 'react';
import CaseSlider from './CaseSlider';
import Boat from './Boat';

const slideArray = [
    {
        title: 'Meet Linda',
        description: 'Linda is an active and involved grandmother of four. She does pilates twice a week and always goes to her annual checkups on schedule.',
        caseSlideImg: require("../img/caseSlide1.png").default,
    },
    {
        title: 'Life-changing event',
        description: "At her most recent checkup, Linda's doctor observed concerning symptoms, resulting in a stage 3 colon cancer diagnosis after tests. Now a patient, she faces the challenges of treatments, alongside worries about her family, finances, and an uncertain future.",
        caseSlideImg: require("../img/caseSlide2.png").default,
    },
    {
        title: 'An extra layer of support',
        description: 'Then, her health plan sends her an invitation to Epilog.',
        description2: "Linda opens Epilog on her phone. She receives a short tutorial about how Epilog works, the holistic approach, and the concept of patient-driven care.",
        caseSlideImg: require("../img/caseSlide3.png").default,
    },
    {
        title: 'Building a relationship with Epilog',
        description: 'Linda continues with her treatment plan alongside Epilog, which accompanies her through the various aspects of her life.',
        description2: (
            <>
                She enjoys chatting with her Epilog representative a few times a week - getting to know her not just clinically, but holistically: discussing what's important to her, describing her support system, and simply having someone to talk to, even vent to at times.
                <br/><br/>
                Epilog is there throughout, a compassionate listening ear.
            </>
        ),
        caseSlideImg: require("../img/caseSlide4.png").default,
    },
    {
        title: 'Symptom Management & Decision-Making',
        description: 'Through these ongoing conversations, Epilog helps Linda manage her symptoms in real time and supports her in navigating important decisions as they arise.',
        description2: (
            <>
                These conversations sometimes reveal care gaps and needs that might otherwise go unnoticed.
                <br/><br/>
                Epilog moves quickly to help address and is there to help with her daily needs, in the time and place right for her.
            </>
        ),
        caseSlideImg: require("../img/caseSlide5.png").default,
    },
    {
        title: 'Key medical junctions',
        description: 'As Linda progresses in her medical journey accompanied by Epilog she discusses her preferences for care.',
        caseSlideImg: require("../img/caseSlide6.png").default,
    },
    {
        title: 'Help with life decisions',
        description: 'It helps her handle personal decisions like how and when to share the news with her loved ones, and how to think about her legacy.',
        caseSlideImg: require("../img/caseSlide7.png").default,
    },
    {
        title: 'Daily quality of life',
        description: "It keeps track of how she's doing and helps improve Linda's daily quality of life.",
        description2: 'Her Epilog experiece is made up of dozens of personalized short sessions, only a few minutes each, aimed to give her a supportive net and a sense of control.',
        caseSlideImg: require("../img/caseSlide8.png").default,
    },
];
const Need = () => {
    const needArr = [
        {
            needBox: "#F6F4FB",
            needImg: require("../img/needImg1.png").default,
            needTxt: (
                <p>
                    <strong>1 in 4 Medicare dollars</strong> are spent in the last 12 months of life - most of it on interventions patients didn't want and crises that could have been caught earlier. The problem isn't end of life. It's everything that leads up to it.
                </p>
            )
        },
        {
            needBox: "#DBE0FF",
            needImg: require("../img/needImg2.png").default,
            needTxt: (<p> Epilog closes that gap. We maintain continuous, trusted relationships with the highest-need patients - uncovering step by step what matters most to them and supporting caregivers, surfacing early signals, and connecting to the most appropriate home-based care solution when need arises. </p>)
        },
        // {
        //     needBox: "#2D2147",
        //     needImg: require("../img/needImg3.png").default,
        //     needTxt: (<p style={{ color: "#fff" }}>The main challenge is identifying the right time for each person to transition to needs-based care, and engaging them in a cost-effective fashion. </p>)
        // }
    ];

    return (
        <section className='heroNxt' id='need'>
            <div className='container'>
                <h1>The Context</h1>
                <p className='needIntro'>
                    The patients who drive the most healthcare cost are those with serious, complex conditions - multiple chronic illnesses, frequent hospitalizations, high social needs. These patients spend years cycling through crises that are largely preventable.
                    <br/><br/>
                    The system's response is episodic: a visit, a discharge, a follow-up call.<br/>Between those moments, no one is watching.
                </p>
                <div className='needWrap'>
                    {
                        needArr.map((needArrData, index) => (
                            <div className='needBox' style={{backgroundColor: needArrData.needBox}} key={index}>
                                <div className="needImg">
                                    <img src={needArrData.needImg} alt=""/>
                                </div>
                                <h3>{needArrData.needTxt}</h3>
                            </div>
                        ))
                    }
                </div>

                <div className='solutionWrap' id='solution'>
                    <ul>
                        <li><h1>Why Epilog?</h1></li>
                        <li><h2 className="solutionText">
                            The two most acute failures in care for complex patients are trust and continuity. Without a trusted relationship, patients don't engage. Without continuity, needs go undetected until they become crises.
                            <br/><br/>
                            Epilog solves both. We build genuine, sustained relationships with the highest-need patients - available 24/7, using behavioral economics to engage at the right moment and in the right way. The result: unmet needs surface earlier, care gaps close faster, and patients are supported through every transition - not just the last one.
                            <br/><br/>
                            Human-to-Human coupled with compassionate technology makes this scalable. Higher adoption, lower cost, and earlier intervention - before complexity becomes catastrophe.
                        </h2></li>
                    </ul>
                    <div className='phoneImg' style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '5px',
                        marginRight: '5px'
                    }}>
                        <iframe src="https://drive.google.com/file/d/15o1rzNTigCu_m50r6vXuk1krac9qxWAD/preview"
                                title="Epilog video"
                                width="500" height="300" allow="autoplay" id={"youtubeIframe"} style={{
                                    maxWidth: '100%',
                        }}></iframe>
                        {/*<iframe width="500" height="300" id={"youtubeIframe"}*/}
                        {/*        src="https://www.youtube.com/embed/8Fh9B4mHS2A?si=VeTNubC9vc7XwwON"*/}
                        {/*        title="YouTube video player" frameBorder="0"*/}
                        {/*        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                        {/*        referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                    </div>
                </div>
            </div>
            <CaseSlider title="How does it feel for patients in everyday life?" dataArr={slideArray} eventName="use_cases_"/>
            <Boat/>
        </section>
    );
};

export default Need;
